import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-stone-50 border-t border-stone-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <span className="text-2xl font-black tracking-tight text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                도어준
              </span>
              <span className="text-[10px] font-semibold text-stone-400 tracking-widest uppercase ml-2">DOORJUN</span>
            </div>
            <p className="text-sm text-stone-500 leading-relaxed mb-5">
              프리미엄 스마트 도어락 브랜드 도어준. 최첨단 보안 기술과 세련된 디자인으로 당신의 집을 더 안전하고 스마트하게.
            </p>
            <div className="flex items-center gap-3">
              {["ri-instagram-line", "ri-twitter-x-line", "ri-pinterest-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-stone-200 text-stone-500 hover:text-stone-900 hover:border-stone-400 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-stone-900 mb-4 pb-3 border-b border-stone-200">
              <a href="/products">제품</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "전체 제품", to: "/products" },
                { label: "카테고리", to: "/categories" },
                { label: "신제품", to: "/products" },
                { label: "베스트셀러", to: "/products" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-stone-500 hover:text-stone-900 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-stone-900 mb-4 pb-3 border-b border-stone-200">
              <a href="/about">고객지원</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "브랜드 소개", to: "/about", external: false },
                { label: "설치 안내", to: "/about", external: false },
                { label: "A/S & 보증", to: "/about", external: false },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-stone-500 hover:text-stone-900 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="tel:01097939490" className="text-sm text-stone-500 hover:text-stone-900 transition-colors cursor-pointer">
                  설치 문의
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-stone-900 mb-4 pb-3 border-b border-stone-200">
              <a href="/contact">Contact</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-stone-400 text-sm" />
                </div>
                <span className="text-sm text-stone-500">경기도 의정부시 용현로 118</span>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-stone-400 text-sm" />
                </div>
                <span className="text-sm text-stone-500">bnk2904@naver.com</span>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-stone-400 text-sm" />
                </div>
                <span className="text-sm text-stone-500">031-853-0666</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-stone-200 gap-3">
          <p className="text-xs text-stone-400">© 2026 도어준 DOORJUN. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" rel="nofollow" className="text-xs text-stone-400 hover:text-stone-600 transition-colors cursor-pointer">개인정보처리방침</a>
            <a href="#" rel="nofollow" className="text-xs text-stone-400 hover:text-stone-600 transition-colors cursor-pointer">이용약관</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
